import React from "react";
import Routes from "./Routes";
import { StagewiseToolbar } from "@stagewise/toolbar-react";
import { ReactPlugin } from "@stagewise-plugins/react";
import { ConfigProvider } from "./context/ConfigContext";
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <AuthProvider>
      <ConfigProvider>
        <StagewiseToolbar config={{ plugins: [ReactPlugin] }} />
        <Routes />
      </ConfigProvider>
    </AuthProvider>
  );
}

export default App;
